import React from 'react';
import { UploadFile } from 'antd/es/upload/interface';
import { IconType } from 'antd/lib/notification';
import { filter, isEmpty, map, first, get } from 'lodash';
import { TFiles } from 'modules/types';
import { EUserLanguage } from 'enums/base.enum';
import { notification } from 'antd';

export const sleep = (n: number) => new Promise((resolve) => setTimeout(resolve, n));

export const getNavigatorLanguage = (lang?: string): EUserLanguage => {
  if (isEmpty(lang) === false) {
    return (first(lang?.split('-')) as EUserLanguage) || EUserLanguage.Korean;
  }

  if (window.location.pathname === '/en') {
    return EUserLanguage.English;
  }

  return EUserLanguage.Korean;
};

export function currentDateString() {
  let dateNow = new Date();
  return `${dateNow.getUTCFullYear()}\
-${('0' + (dateNow.getUTCMonth() + 1)).slice(-2)}\
-${('0' + dateNow.getUTCDate()).slice(-2)}`;
}

//멘토링 신청하기 버튼을 눌렀을 때 파일첨부한 files값에서 바디로 전달해줄 파라미터값 만들어주는 함수
export function filteredFileNames(files: UploadFile[] & TFiles[]): number[] {
  return map(
    //files 배열 중에서 status가 'done'인 것은  제외시킨 "배열!"을 맵돌린다
    filter(files, (f) => f.status === 'done'),
    //response.id 가 있으면 response.id값을 뽑아내고 없으면 uid 값을 뽑아낸다
    (v) => (v.response ? get(v, 'response.id') : get(v, 'uid')),
  );
}

export function getLocalDate() {
  const timezoneOffset = new Date().getTimezoneOffset() * 60000;
  const timezoneDate = new Date(Date.now() - timezoneOffset);

  return timezoneDate.toISOString().slice(0, 10);
}

export function dataURItoBlob(dataURI: string) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  const byteString = window.atob(dataURI.split(',')[1]);
  // separate out the mime component
  const mimeString = dataURI
    .split(',')[0]
    .split(':')[1]
    .split(';')[0];
  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length);
  // create a view into the buffer
  const ia = new Uint8Array(ab);
  // set the bytes of the buffer to the correct values
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  // write the ArrayBuffer to a blob, and you're done
  return new Blob([ab], { type: mimeString });
}

export const showNotification = (type: IconType, message: string | React.ReactNode) => {
  notification[type]({
    top: 5,
    duration: 4,
    message: message,
  });
};

export const setProp = (name: string, prop: any, isImportant: boolean = false) => {
  return prop !== undefined ? `${name}: ${prop}${isImportant ? ' !important' : ''};` : '';
};

export const makeComma = (number: string | number) => {
  const thisNumber = Number(number);

  if (isNaN(thisNumber)) return number;
  if (thisNumber === 0 || String(thisNumber).length < 4) return thisNumber;

  const reg = /(^[+-]?\d+)(\d{3})/;
  let n = String(thisNumber);

  while (reg.test(n)) n = n.replace(reg, '$1,$2');

  return n;
};

export const trim = (str: string) => {
  return str ? str.trim() : '';
};

export const getUrlQuery = (search: string) => {
  const params: { [key: string]: string } = {};
  search.replace(/[?&]+([^=&]+)=([^&]*)/gi, (str: string, key: string, value: string) => {
    params[key] = value;
    return str;
  });
  return params;
};

export const toUpperCase = (str: string) => {
  const convertedString = str.charAt(0).toUpperCase() + str.slice(1);
  return convertedString;
};

export function numberFormat(x: number) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

//가격을 한글로 표시하는 함수 ex) 2만5,000
//천단위도 표시하고 싶을 경우 String(numberToKorean(200000)).replace(',000','천')
export function numberToKorean(number: number) {
  const inputNumber: any = number < 0 ? false : number;
  const unitWords = ['', '만', '억', '조', '경'];
  const splitUnit = 10000;
  const splitCount = unitWords.length;
  const resultArray = [];
  let resultString = '';

  for (let i = 0; i < splitCount; i++) {
    let unitResult = (inputNumber % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i);
    unitResult = Math.floor(unitResult);
    if (unitResult > 0) {
      resultArray[i] = unitResult;
    }
  }

  for (let i = 0; i < resultArray.length; i++) {
    if (!resultArray[i]) continue;
    resultString = String(numberFormat(resultArray[i])) + unitWords[i] + resultString;
  }

  return resultString;
}

//최근 n개년도 배열 리턴 함수
export const makeLastNYearsList = (num: number): Array<number> => {
  let nowYear = Number(new Date().getFullYear());
  let years = [];
  while (years.length !== num) {
    let countNum: number = years.length;
    years.push(nowYear - countNum);
  }
  return years;
};
